/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicCopilotGovernanceMetricsProcessor extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicCopilotGovernanceMetricsProcessor");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicCopilotGovernanceMetricsProcessor.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicCopilotGovernanceMetricsProcessor>): BackgroundJobPayloadForPeriodicCopilotGovernanceMetricsProcessor {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicCopilotGovernanceMetricsProcessor(), model);
        BackgroundJobPayloadForPeriodicCopilotGovernanceMetricsProcessor.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicCopilotGovernanceMetricsProcessor>): BackgroundJobPayloadForPeriodicCopilotGovernanceMetricsProcessor {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicCopilotGovernanceMetricsProcessor.newInstance(<BackgroundJobPayloadForPeriodicCopilotGovernanceMetricsProcessor> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicCopilotGovernanceMetricsProcessor) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicCopilotGovernanceMetricsProcessor.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicCopilotGovernanceMetricsProcessor): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicCopilotGovernanceMetricsProcessor.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
